(() => {
  angular
    .module('complianceFrameworkApp.vms')
    .controller('ContractDetailController', ContractDetailController);

  /* ngInject */
  function ContractDetailController($state, $stateParams, Flash, config, contractService, sessionService) {
    const vm = this;

    vm.config = config;
    vm.contract = {};
    vm.deleteContract = deleteContract;
    vm.id = $stateParams.id;
    vm.sessionService = sessionService;
    vm.vendorId = $stateParams.vendorId;

    activate();

    function activate() {
      getContract();
    }

    function deleteContract() {
      contractService(sessionService.getAuthToken()).delete({ id: vm.id }, _ => {
        Flash.create('success', 'The contract was successfully deleted.');
        $state.go('application.vms.contracts', {});
        angular.element('#deleteContractModal').modal('hide');
      });
    }

    function getContract() {
      contractService(sessionService.getAuthToken()).get({ id: vm.id }, response => vm.contract = response);
    }
  }
})();
